import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

/**
 * progress bar
 * @returns
 */
export default function CircularIndeterminate() {
	return (
		<Box sx={{ display: 'flex' }}>
			<CircularProgress />
		</Box>
	)
}
